import React, { useEffect, useRef } from "react";
import "./imgComp.css";

export default function ImgComp(props) {
  return (
    <div className="imgComp-main">
      {/* <div className="imgHeader">{props.header}</div> */}
      <div
        className={`imgComp-bg ${props.bgProp}`}
        style={{ backgroundImage: `url(${props.img})` }}
      >
        {props.shape}
      </div>
      <div className="rightText-wrapper">
        <div className="rightText">{props.rightText1}</div>
        <div className="rightText rightText2">{props.rightText2}</div>
      </div>
      <div className="leftText-wrapper">
        <div className="leftText ">{props.leftText1}</div>
        <div className="leftText leftText2">{props.leftText2}</div>
      </div>

      <div className="component-button">
        <div className="component-button-border"></div>
        <div className="component-button-text">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://www.teilor.ro/fancy-cuts.html"}
          >
            VEZI COLECȚIA
          </a>
        </div>
      </div>
      {/* <div className="component-text"> */}
      {/* Arată cine ești și fii gata să strălucești. <br />
        <span>pentru tine.</span>
        <br />
        Răsfață-te cu bijuteriile care vorbesc despre tine. <br /> */}
      {/* </div> */}
    </div>
  );
}
